import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "Fan";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

export const FanService = {
	endpoint,
	list: async (search: string, page: number, pageSize: number) =>
		await FetchInterceptor(url(`/List?search=${encodeURIComponent(search || "")}&page=${page}&pageSize=${pageSize}`), { headers: json, method: "GET" }),
	setPriority: async (clubFanId: number, isPriority: boolean) =>
		await FetchInterceptor(url(`/Priority/${clubFanId}`), { body: JSON.stringify({ isPriority }), headers: json, method: "POST" }),
	exportUrl: () => url("/Export"),
	exportMarketingUrl: () => url("/ExportMarketing")
};

const audienceUrl = (path: string) => `${environment.server.apiURL}/Audience${path}`;

export const AudienceService = {
	getAll: async () => await FetchInterceptor(audienceUrl(""), { headers: json, method: "GET" }),
	downloadUrl: (key: string, optedInOnly: boolean) => audienceUrl(`/${key}/Download?optedInOnly=${optedInOnly}`)
};
